<y42-list-view
  [id]="id"
  [name]="'Jobs'"
  [canAdd]="false"
  [hideSearchWhenNoData]="false"
  [searchLabel]="'Search'"
  [searchPlaceholder]="'Search for import jobs'"
  [columnDefs]="columnDefs"
  [gridOptions]="gridOptions"
  [frameworkComponents]="frameworkComponents"
  [messages]="messages"
  [defaultQuickFilters]="defaultQuickFilters"
  [quickFilterKey]="quickFilterKey"
  [hideLoader]="true"
  [incrementalLoading]="true"
  (gridRowClicked)="gridRowClicked($event)"
>
  <ng-container y42ListViewSearchFields>
    <y42-refresh-jobs-button class="mr-2"></y42-refresh-jobs-button>
    <mat-form-field class="w-1/2 no-padding pr-2" appearance="outline">
      <mat-label>Date range</mat-label>
      <mat-date-range-input
        [formGroup]="selectedDateRangeForm"
        [rangePicker]="picker"
        [max]="max"
        class="text-gray-1100"
      >
        <input
          matStartDate
          placeholder="Start date"
          [formControl]="selectedDateRangeForm.controls.from"
          [attr.data-test]="'job-list-view-content-input-start-date'"
        />
        <input
          matEndDate
          placeholder="End date"
          [formControl]="selectedDateRangeForm.controls.to"
          [attr.data-test]="'job-list-view-content-input-end-date'"
        />
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  </ng-container>
</y42-list-view>
